const order = [
  ["XS", "XS/34"],
  ["S", "S/36"],
  ["M", "M/38/40"],
  ["L", "L/42"],
  ["XL", "XL/44"],
  ["XXL", "XXL/46"],
  ["XXXL", "XXXL/48"],
  ["ONESIZE", "ONESIZE"]
];

/**
 * Sorts an array of strings that contains size values
 */
class SortSizePipe {
  transform(list, asc = true) {
    return list.slice().sort((size1, size2) => {
      const indexSize1 = order.findIndex((o) => o.includes(size1));
      const indexSize2 = order.findIndex((o) => o.includes(size2));

      return asc ? indexSize1 - indexSize2 : indexSize2 - indexSize1;
    });
  }
}

const sortSizePipe = new SortSizePipe();
export default sortSizePipe;
